import { createApi } from '@reduxjs/toolkit/query/react'
import { createBaseQueryWithReauth } from 'store/auth/base-query-with-reauth'
import {
  CreatePortalAccessRequest,
  PortalAccessSummary,
  PortalLinkResponse,
} from './customer-portal.types'

const baseUrl = `${process.env.REACT_APP_ONBOARDING_SERVICE_API}`

export const customerPortalApi = createApi({
  reducerPath: 'customerPortalApi',
  baseQuery: createBaseQueryWithReauth(baseUrl!),
  tagTypes: ['CustomerPortalAccess'],
  endpoints: (builder) => ({
    getPortalAccess: builder.query<PortalAccessSummary, { customerId: string }>({
      query: ({ customerId }) => ({
        url: `oapi/v1/customer/portal-access`,
        params: { customerId },
      }),
      providesTags: (_result, _error, { customerId }) => [
        { type: 'CustomerPortalAccess', id: customerId },
      ],
    }),

    generatePortalAccess: builder.mutation<PortalLinkResponse, CreatePortalAccessRequest>({
      query: (body) => ({
        url: `oapi/v1/customer/portal-access`,
        method: 'POST',
        body,
      }),
      invalidatesTags: (_result, _error, { customerId }) => [
        { type: 'CustomerPortalAccess', id: customerId },
      ],
    }),

    revokePortalAccess: builder.mutation<void, { customerId: string }>({
      query: ({ customerId }) => ({
        url: `oapi/v1/customer/portal-access`,
        method: 'DELETE',
        params: { customerId },
      }),
      invalidatesTags: (_result, _error, { customerId }) => [
        { type: 'CustomerPortalAccess', id: customerId },
      ],
    }),
  }),
})

export const {
  useGetPortalAccessQuery,
  useGeneratePortalAccessMutation,
  useRevokePortalAccessMutation,
} = customerPortalApi
